import { VCObserver } from './vc-observer';
let instance = null;
export const getVCObserver = (opts = {}) => {
  if (instance === null) {
    instance = new VCObserver(opts);
  }
  return instance;
};